import React from "react";

export default function BulletTriangle(props: any) {
    return (
    <svg id="Bullet_triangle" xmlns="http://www.w3.org/2000/svg" width="14" height="14.002" viewBox="0 0 14 14.002" {...props}>
      <path id="Bullet_triangle-2" data-name="Bullet_triangle" d="M-1251-12028v14l-14-14" transform="translate(1265 12028.002)" fill="#113b7b"/>
    </svg>
    );
}